import { Translate } from '@/components';
import colors from '@/theme/colors';
import { styled } from '@mui/system';
import { css, cx } from '@emotion/css';
import { forwardRef } from 'react';
import { darken } from '@mui/material/styles';
import CircularProgress from '@mui/material/CircularProgress';
import { ButtonBase, ButtonBaseProps } from './ButtonBase';
import {
  ButtonPrimaryMediumStyles,
  ButtonPrimarySmallStyles,
  ButtonPrimaryLargeStyles,
} from './Buttons.styles';

export const ButtonPrimary = forwardRef<HTMLButtonElement, ButtonBaseProps & { loading?: boolean }>(
  (
    {
      children,
      className,
      background = colors.jungle,
      fontColor = colors.white,
      loading = false,
      disabled,
      ...rest
    }: ButtonBaseProps & { loading?: boolean },
    ref
  ) => (
    <ButtonBase
      ref={ref}
      className={cx(
        className,
        css`
          &.MuiButton-root {
            background: ${background} !important;
            color: ${fontColor} !important;
          }
          &.MuiButton-root:hover {
            background: ${darken(background, 0.2)} !important;
            color: ${fontColor} !important;
          }
          &.MuiButton-root:focus {
            background: ${darken(background, 0.4)} !important;
            color: ${fontColor} !important;
          }
        `
      )}
      disabled={loading || disabled}
      aria-busy={loading || undefined}
      {...rest}
    >
      {loading ? (
        <>
          <CircularProgress size={20} color="inherit" aria-hidden="true" />
          <span className="sr-only">Loading</span>
        </>
      ) : (
        children
      )}
    </ButtonBase>
  )
);

export const ButtonPrimaryMedium = styled(ButtonPrimary)(ButtonPrimaryMediumStyles);

export const ButtonPrimarySmall = styled(ButtonPrimary)(ButtonPrimarySmallStyles);
export const ButtonPrimaryLarge = styled(ButtonPrimary)(ButtonPrimaryLargeStyles);
